<template>
    <div class="integralGiftBox">
        <md-field>
            <md-field-item title="积分查询" :content="selectorValue" @click="showSelector" arrow solid />
        </md-field>
        <div class="integralGiftScroll">
            <div class="scrollContent">
                <div class="item-content" @click="gotoIntegralGiftFn(item)" v-for="(item, index) in newGiftList" :key="index">
                    <img  class="imgStyle" :src="`/manager/fileserver/file/download?id=${item.pic0}`" />
                    <div class="priceBox"><span class="price">{{item.score}}积分</span><span class="integral">原价{{item.giftPrice}}</span></div>
                    <!--<span class="goodNameDate">{{item.beginDate}} ~ {{item.endDate}}</span>-->
                    <span class="goodName">{{item.giftName}}</span>
                </div>
                <!--<div class="item-content">-->
                    <!--<img class="imgStyle" src="http://gju2.alicdn.com/tps/i3/O1CN01MBwOd01IBAnP6zK0n_!!1-juitemmedia.gif_400x400Q90.jpg_.webp" />-->
                    <!--<span class="integral">1000积分</span>-->
                    <!--<span class="goodName">TP-LINK路由器</span>-->
                <!--</div>-->
            </div>
        </div>
        <md-selector
                v-model="isSelectorShow"
                default-value="2"
                :data="shopList"
                max-height="320px"
                title="请选择积分"
                large-radius
                @choose="onSelectorChoose"
        ></md-selector>
    </div>
</template>

<script>
    export default {
        name: "integralGift",
        mounted() {
            document.title = "积分换礼"
            let dt = new URLSearchParams()
            dt.append('status', 2)
            this.serverDatra(dt)
        },
        computed:{
            newGiftList(){
                return this.giftList.filter(item =>{
                    item.beginDate = item.beginDate.split(' ')[0]
                    item.endDate = item.endDate.split(' ')[0]
                    if((item.inventoryNum-item.totalNum) > 0){
                        return item
                    }

                })
            }
        },
        data(){
          return{
              isSelectorShow: false, //选择列表状态
              selectorValue: "请选择积分", //选择器内容
              shopList: [
                  //门店数据
                  { value: {a:0,b:5000}, text: "5000积分以下" },
                  { value: {a:5000,b:10000}, text: "5000 ~ 10000积分" },
                  { value: {a:10000,b:''}, text: "10000积分以上" }
              ],
              giftList:[]
          }
        },
        methods:{

            gotoIntegralGiftFn(item){ //跳转到礼品详情
                let dt = JSON.stringify(item)
                this.$router.push({name:'integralGiftConvert', query:{itemData:dt}})
            },
            showSelector() {
                //选择器改变状态
                this.isSelectorShow = true;
            },
            onSelectorChoose({ text, value }) {
                //获取选择器获取的内容
                this.selectorValue = text

                let dt = new URLSearchParams()
                dt.append('status', 2)
                dt.append('startScore',value.a)
                dt.append('endSocre', value.b)
                this.serverDatra(dt)
            },
            serverDatra(dt){ //获取数据
                this.$http.post('/sangto-wrm/vip/scoreGift/sync').then(() => {
                    this.$http.post('/sangto-wrm/vip/scoreGift/wechatPage', dt).then(({data})=>{

                        this.giftList = data.data.rows
                    })
                })

            }
        }
    }
</script>

<style lang="scss" scoped>
.integralGiftBox{
    width: 100%;
    height: 100%;
    /*.memberRuleNav{*/
        /*width: 100%;*/
        /*height: 45px;*/
        /*background-color: #6cf;*/
        /*box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);*/
        /*line-height: 45px;*/
    /*}*/
    /*.iconzuojiantou{*/
        /*font-size: 24px;*/
        /*color: #fff;*/
        /*margin-left: 4px;*/
        /*padding: 6px;*/
    /*}*/
    .price{
        color: #ee0000;
        font-size: 14px;
        font-weight: bold;
    }
    .priceBox{
        margin-top: 11px;
        width: 90%;
        display: flex;
        justify-content: space-between;
    }
    .integralGiftScroll{
        position: absolute;
        top: 90px;
        left: 0;
        right: 0;
        bottom: 0;
        overflow-x: hidden;
        overflow-y: auto;
        background-color: #f6f6f6;
        -webkit-overflow-scrolling : touch;
    }
    .scrollContent{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        padding-bottom: 20px;
    }
    .item-content{
        width: 47%;
        height: 247px;
        background-color: #fff;
        margin-left: 2%;
        margin-top: 2%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .imgStyle{
        margin-top: 8px;
        width: 90%;
        height: 170px;
    }
    .integral{
        /*margin-top: 11px;*/
        /*width: 90%;*/
        font-size: 14px;
        color: #fca826;
    }
    .goodName{
        margin-top: 6px;
        width: 90%;
        font-size: 14px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #555;
    }
    /*.goodNameDate{*/
        /*margin-top: 6px;*/
        /*width: 90%;*/
        /*font-size: 12px;*/
        /*overflow: hidden;*/
        /*white-space: nowrap;*/
        /*text-overflow: ellipsis;*/
        /*color: #555;*/
    /*}*/
}
</style>
